import { get, post } from "@crunchit/http-client";
import { IContextDto, ILabelDto, IProductDto } from "@crunchit/types";
import { getToken, getEnvironment } from "utils/helpers/service";

const api = process.env.REACT_APP_PRODUCT_URI || `product.${getEnvironment()}crunchy.ninja/api`;

const ProductService = {
  getProductById: async (productId: number, productInstanceId: string) => {
    return get<IProductDto>(`${api}/product/${productId}?instanceId=${productInstanceId}`, getToken());
  },
  getLabels: async (productInstanceId: string) => {
    return get<ILabelDto[]>(`${api}/label?instanceId=${productInstanceId}`, getToken());
  },
  createContext: async (productIds: number[]) => {
    return post<IContextDto>(`${api}/context`, productIds, getToken());
  },
};

export default ProductService;
